var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"id":_vm.id}},[_c('div',{staticClass:"modal-body",attrs:{"slot":"body"},slot:"body"}),_vm._v(" "),_c('div',{staticClass:"modal-footer",attrs:{"slot":"footer"},slot:"footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }